
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import AppDrawerMixin from '@/mixins/AppDrawerMixin';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import NotificationCard from '@/components/Notifications/NotificationCard.vue';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
@Component({
  components: {AppBreadcrumbs, NotificationCard},
})
export default class AppHeader extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  clipped = false;
  get appTitle() {
    return process.env.VUE_APP_NAME;
  }
  notifications = [
    {
      id: 2,
      message: 'Test Seleksi Awal',
      meta: '/account',
      created_at: '11-02-2022',
    },
    {
      id: 1,
      message: 'Psikotest',
      meta: '/account',
      created_at: '11-01-2022',
    },
  ];
  counter = 0;
  interval: any = null;
  listStatus = [];
  async mounted() {
    this.facthData();
  }
  async facthData() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('jobs/allStatusApply');
      this.finishLoading('detail');
      this.listStatus = data?.status;
    } catch (e) {
      this.catchError(e);
    }
  }
  created() {
    this.interval = setInterval(() => {
      this.facthData();
    }, 600000);
  }
  destroyed() {
    clearInterval(this.interval);
  }
}
